module.exports = __webpack_public_path__ + "img/dg-nav-below-nav-mazda.9de1ce5d.png";